namespace Ir.Components.Filters.ScopeActionFilter {

    interface IScopeActionFilterViewModel{
        filter: Filter;
        scopeActions: Array<object>;
        visible: KnockoutComputed<boolean>;
        selectBoxSettings: DevExpress.ui.dxSelectBox.Properties;
        selectBoxComponent: DevExpress.ui.dxSelectBox;
    }

    interface IScopActionParameter {
        filter: Filter;
    }

    export function getViewModel(this: IScopeActionFilterViewModel, params: IScopActionParameter, componentInfo) {
        let self = this;
        this.filter = params.filter;

        let isDateFilter = this.filter.filterEditorType() === FilterEditorTypeEnum.Date || this.filter.filterEditorType() === FilterEditorTypeEnum.DateRange;
        this.scopeActions = [
            { id: ScopeActionEnum.Default, text: "Default", icon: "join", description: isDateFilter ? "Overwrite selections from higher level" : "Combine multiple selection filters" },
            { id: ScopeActionEnum.Combine, text: "Combine", icon: "join_inner", description: isDateFilter ? "Use the parent filter as the base date for the Date Range selected" : "Combine multiple selection filters" },
            { id: ScopeActionEnum.Overwrite, text: "Overwrite", icon: "join_right", description: "Overwrite selections from higher level" }
        ];

        this.visible = ko.computed(function () {
            let allowEdit = loggedUser.permissions.workbooks() || (workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.ViewOnly && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted);
            return allowEdit && self.filter.scope() !== ContainerScopeEnum.Mapping &&
                self.filter.filterEditorType() !== FilterEditorTypeEnum.Date && self.filter.filterEditorType() !== FilterEditorTypeEnum.TextBox &&
                self.filter.filterEditorType() !== FilterEditorTypeEnum.Numeric;
        });

        this.selectBoxSettings = {
            dataSource: this.scopeActions,
            displayExpr: 'text',
            valueExpr: 'id',
            value: this.filter.scopeAction(),
            width: 53,
            height: 28,
            dropDownOptions: {
                width: isDateFilter ? 365 : 250,
            },
            fieldTemplate(data, container) {
                const icon = $(`<i class="ms">${data.icon}</i>`).css("vertical-align", "middle");
                const txt = $("<div>").dxTextBox({
                    value: "",
                    readOnly: true,
                    inputAttr: { 'aria-label': 'Name' },
                });
                const div = $("<div>").css({ "width": "28px", "text-align": "center" }).append(icon).append(txt);
                container.append(div);
            },
            itemTemplate(data) {
                return `<div><span>${data.text}  <small>- ${data.description}</small></span></div>`;
            },
            onInitialized(e) {
                self.selectBoxComponent = e.component;
            },
            onValueChanged: function (data) {
                if (data.previousValue !== data.value) {
                    self.filter.scopeAction(data.value);

                    if (data.value === ScopeActionEnum.Combine && data.previousValue !== ScopeActionEnum.Combine && self.filter.dateRange() === irGlobal.customDate.custom &&
                        (self.filter.filterEditorType() === FilterEditorTypeEnum.DateRange || self.filter.filterEditorType() === FilterEditorTypeEnum.Date)) {
                        irGlobal.showToast("Changed the Date Range to Today. Combine only works with a Date Range", "warning");
                        self.filter.dateRange(irGlobal.customDate.today);
                    }

                    if (self.filter.isCombinedDate()) {
                        if (self.filter.dateRange() === irGlobal.customDate.custom && (!self.filter.dateRangeConfig.lastDateUsed() || self.filter.dateRangeConfig.lastDateUsed() === 0)) {
                            self.filter.dateRange(irGlobal.customDate.today);
                        }
                    }

                    if (self.filter.isInNotInFilter) {
                        self.filter.requireDataSourceUpdate(true);
                    }

                    self.filter.publish();
                }
            }
        }

        this.filter.scopeAction.subscribe(function (newValue) {
            if (self.selectBoxComponent && newValue != self.selectBoxComponent.option("value")) {
                self.selectBoxComponent.option("value", newValue);
            }
        });
    }
}